 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activity~gifts~presell~seckill-index~special":"activity~gifts~presell~seckill-index~special","activity":"activity","gifts":"gifts","presell":"presell","seckill-index":"seckill-index","special":"special","address":"address","bind-account":"bind-account","��ҳ":"��ҳ","distributor":"distributor","error":"error","invoice-list":"invoice-list","management":"management","medicare":"medicare","my-credit":"my-credit","myorder":"myorder","news":"news","news-detail":"news-detail","order-detail":"order-detail","order-invoice":"order-invoice","order-invoice-detail":"order-invoice-detail","order-refund":"order-refund","order-refund-apply-for-refund":"order-refund-apply-for-refund","order-refund-detail":"order-refund-detail","order-return":"order-return","order-return-apply-for-return":"order-return-apply-for-return","order-return-detail":"order-return-detail","presell-index":"presell-index","purchase-history":"purchase-history","purchase-history-detail":"purchase-history-detail","purchase-product-stocks":"purchase-product-stocks","regionsell":"regionsell","success":"success","商品详情页":"商品详情页"}[chunkId]||chunkId) + "." + {"activity~gifts~presell~seckill-index~special":"0283bcbe","activity":"109a0277","gifts":"44873607","presell":"8f355d77","seckill-index":"3c3ed545","special":"f2ba7b7b","address":"4509e007","bind-account":"431fbd5e","chunk-6ecf838b":"6faf063c","chunk-d4795ec6":"8e2b91c7","��ҳ":"3717754b","chunk-88e5b7fa":"31ac95c2","distributor":"2695d61c","error":"bfe1dd6b","invoice-list":"1aa82545","management":"23f4c45b","medicare":"417bae42","my-credit":"cbae2497","myorder":"4c8e4ea5","news":"122de3b8","news-detail":"e1260afb","order-detail":"2682bbe3","order-invoice":"c46cc5bb","order-invoice-detail":"a07136d6","order-refund":"32b353b9","order-refund-apply-for-refund":"a8a3aac5","order-refund-detail":"22d943cf","order-return":"a34bcac5","order-return-apply-for-return":"a03a25db","order-return-detail":"33246512","presell-index":"513e18bf","purchase-history":"7bce058c","purchase-history-detail":"fa146c59","purchase-product-stocks":"522f592d","regionsell":"ca650af7","success":"286d2d31","商品详情页":"8a8966ff"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activity~gifts~presell~seckill-index~special":1,"activity":1,"gifts":1,"presell":1,"seckill-index":1,"special":1,"address":1,"bind-account":1,"chunk-6ecf838b":1,"chunk-d4795ec6":1,"��ҳ":1,"chunk-88e5b7fa":1,"distributor":1,"error":1,"invoice-list":1,"management":1,"medicare":1,"my-credit":1,"myorder":1,"news":1,"news-detail":1,"order-detail":1,"order-invoice":1,"order-invoice-detail":1,"order-refund":1,"order-refund-apply-for-refund":1,"order-refund-detail":1,"order-return":1,"order-return-apply-for-return":1,"order-return-detail":1,"presell-index":1,"purchase-history":1,"purchase-history-detail":1,"purchase-product-stocks":1,"regionsell":1,"success":1,"商品详情页":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activity~gifts~presell~seckill-index~special":"activity~gifts~presell~seckill-index~special","activity":"activity","gifts":"gifts","presell":"presell","seckill-index":"seckill-index","special":"special","address":"address","bind-account":"bind-account","��ҳ":"��ҳ","distributor":"distributor","error":"error","invoice-list":"invoice-list","management":"management","medicare":"medicare","my-credit":"my-credit","myorder":"myorder","news":"news","news-detail":"news-detail","order-detail":"order-detail","order-invoice":"order-invoice","order-invoice-detail":"order-invoice-detail","order-refund":"order-refund","order-refund-apply-for-refund":"order-refund-apply-for-refund","order-refund-detail":"order-refund-detail","order-return":"order-return","order-return-apply-for-return":"order-return-apply-for-return","order-return-detail":"order-return-detail","presell-index":"presell-index","purchase-history":"purchase-history","purchase-history-detail":"purchase-history-detail","purchase-product-stocks":"purchase-product-stocks","regionsell":"regionsell","success":"success","商品详情页":"商品详情页"}[chunkId]||chunkId) + "." + {"activity~gifts~presell~seckill-index~special":"60207996","activity":"14453aa1","gifts":"eee33e97","presell":"93b2dca4","seckill-index":"ab9503cd","special":"7cfa2031","address":"8f152d0f","bind-account":"34710a1c","chunk-6ecf838b":"916d7f93","chunk-d4795ec6":"4ab4ae0d","��ҳ":"a208bd72","chunk-88e5b7fa":"fe088bf4","distributor":"bc99384a","error":"bc2b4714","invoice-list":"883cab29","management":"9a5a8792","medicare":"ab331d02","my-credit":"bcf49ba0","myorder":"e1311e9d","news":"661e4edf","news-detail":"d14b73e4","order-detail":"cabeb486","order-invoice":"292eb781","order-invoice-detail":"6c15535d","order-refund":"af143768","order-refund-apply-for-refund":"bf7b3350","order-refund-detail":"de87e1ae","order-return":"5c9272de","order-return-apply-for-return":"6fb6f574","order-return-detail":"aace5936","presell-index":"b96fb95c","purchase-history":"16022b8e","purchase-history-detail":"33654bdb","purchase-product-stocks":"bf292c7b","regionsell":"0b5df0e9","success":"aef68faa","商品详情页":"6ed98a0d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
 					linkTag.crossOrigin = "anonymous";
 				}
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/webpack/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
